/**
 * AllSet — respect `prefers-reduced-motion` on autoplaying slideshows.
 *
 * Horizon's slideshow pauses on hover and when the tab is hidden, but it does not consult
 * `prefers-reduced-motion`, so a carousel set to autoplay keeps advancing for people who
 * have asked their operating system to stop motion (WCAG 2.2.2 Pause/Stop/Hide, 2.3.3).
 *
 * Driven from outside rather than by editing `assets/slideshow.js`:
 *   - `pause()` sets the component's `paused` flag,
 *   - `resume()` returns early while that flag is set.
 * So every later resume — tab refocus, pointer-up, arrow click — stays a no-op without
 * touching the theme's own file. Nothing to re-apply after a theme update.
 *
 * Arrows, dots, swipe and drag all keep working; only the automatic advance stops.
 */
const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function apply(query) {
  for (const slideshow of document.querySelectorAll('slideshow-component[autoplay]')) {
    // Guard: only act on upgraded custom elements, which have these methods.
    if (typeof slideshow.pause !== 'function' || typeof slideshow.resume !== 'function') continue;

    if (query.matches) {
      slideshow.pause();
    } else {
      slideshow.resume();
    }
  }
}

function init() {
  const query = window.matchMedia(REDUCED_MOTION);

  apply(query);
  // Re-run when the OS setting is toggled while the page is open.
  query.addEventListener('change', () => apply(query));

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', () => apply(query));
}

// Components are upgraded asynchronously; waiting avoids racing their constructor.
customElements.whenDefined('slideshow-component').then(init);
